import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import { setDateFormat } from '../../../../../lib/moment';
import { setDash } from '../../../../../lib/common';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';

/**
 *  추천 브랜드에 연결된 브랜드 아이템 리스트 컬럼
 */
export const columns = () => {
  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'브랜드 ID'} />,
      dataIndex: 'id',
      render: (value) => <OpenBrandDetail text={value} storeId={value} />,
    },
    {
      title: <TableColumnTitle title={'브랜드명'} />,
      dataIndex: 'storeName',
    },
    {
      title: <TableColumnTitle title={'상점 티어'} />,
      dataIndex: 'storeTier',
      render: (value) => setDash(value),
    },
    {
      title: '서브 텍스트',
      dataIndex: 'subText',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'입점 일자'} />,
      dataIndex: 'entryDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};
